import { useSelector } from 'react-redux';
import { AppState } from '../../../../Configs/store/AppReducer';

export const useLoggedUser = () => {
    const userLogged = useSelector((state: AppState) => state.Authentication);
    return userLogged.first_login;
};
